'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconPath = require('../../services/IconPath');

var _IconPath2 = _interopRequireDefault(_IconPath);

var _Notification = require('../../managewidgets/components/notification/Notification');

var _Notification2 = _interopRequireDefault(_Notification);

var _Label = require('../../managewidgets/components/label/Label');

var _Label2 = _interopRequireDefault(_Label);

var _ScreenMessage = require('./ScreenMessage.scss');

var _ScreenMessage2 = _interopRequireDefault(_ScreenMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @type { React.StatelessComponent } */
var ScreenMessage = function ScreenMessage(props) {

  var getLabel = function getLabel(message) {
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var value = message.value,
        isError = message.isError,
        isHTML = message.isHTML;


    if (isError) {
      // some errors come directly from API response so we dont want to blindly
      // render the message as HTML as it can echo user input and expose XSS issues
      return _react2.default.createElement(
        'li',
        { key: value, className: className },
        value
      );
    } else {
      // we should only be setting as raw HTML when we have full control of text being rendered
      // and we are sure the text is not dynamic, running risk of rendering user input
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Label2.default, { key: value, value: value, isHTML: isHTML, className: className })
      );
    }
  };

  var getSubMessages = function getSubMessages() {
    var subMessages = props.subMessages;


    if (!subMessages || subMessages.length === 0) {
      return null;
    }

    var cache = new _set2.default();

    var children = subMessages.reduce(function (accumulator, subMessage) {
      // filter out duplicates
      var isNew = !cache.has(subMessage.value);

      if (isNew) {
        cache.add(subMessage.value);
        accumulator.push(getLabel(subMessage, _ScreenMessage2.default.subMessage));
      }

      return accumulator;
    }, []);

    return children;
  };

  if (props.message.value) {
    var statusIcon = '';
    switch (props.status) {
      case _Notification.NotificationStatus.SUCCESSFUL:
        statusIcon = 'Flag_Enabled';
        break;
      case _Notification.NotificationStatus.ERROR:
        statusIcon = 'Status_Warning';
        break;
      case _Notification.NotificationStatus.INFORMATIONAL:
        statusIcon = 'Application_Information';
        break;
      case _Notification.NotificationStatus.WARNING:
        statusIcon = 'Status_Warning';
        break;
      default:
        statusIcon = 'Flag_Enabled';
        break;
    }

    return _react2.default.createElement(
      _Notification2.default,
      (0, _assign2.default)({}, props, {
        automationName: 'msg',
        message: getLabel(props.message, _ScreenMessage2.default.message),
        status: props.status,
        statusIcon: _IconPath2.default.get(statusIcon) }),
      getSubMessages()
    );
  } else {
    return null;
  }
};

ScreenMessage.propTypes = {
  status: _propTypes2.default.oneOf([_Notification.NotificationStatus.ERROR, _Notification.NotificationStatus.INFORMATIONAL, _Notification.NotificationStatus.WARNING, _Notification.NotificationStatus.SUCCESSFUL]),
  message: _propTypes2.default.shape({
    value: _propTypes2.default.string,
    isHTML: _propTypes2.default.boolean
  }).isRequired,
  onClose: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  subMessages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string,
    isError: _propTypes2.default.boolean,
    isHTML: _propTypes2.default.boolean
  })),
  screenKey: _propTypes2.default.string
};

exports.default = ScreenMessage;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/screenmessage/ScreenMessage.js
// module id = 353
// module chunks = 10